<template>

    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Area Of Focus</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 
        <section class="areas section grid-page">
            <div class="container">
                <div class="row">
                    <div v-for="cat in categories" :key="cat.id">
                        <h4>{{cat.name}}</h4>
                        <div v-for="subCat in cat.subCategories" :key:="subCat.id">
                            <div class="col-lg-4 col-md-6">
                                <div class="single-area wow fadeInUp" data-wow-delay=".2s">
                                    <div class="area-image">
                                        <a href="area-details.html"><img src="assets/images/areas/areas-1.jpg"
                                                alt="#"></a>
                                    </div>
                                    <div class="content">
                                        <h3><a href="service-single.html">{{subCat.name}}</a></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->


        <section class="areas section grid-page">
            <div class="container">
                <div class="row" v-for="cat in categories" :key="cat.id">
                    <h3 class="mt-5" style="font-size:large; color:#3c3c94;">{{cat.name}}</h3>
                    <div class="col-lg-4 col-md-6 col-12" v-for="subCat in cat.subCategories" :key:="subCat.id">
                        <div class="single-area wow fadeInUp" data-wow-delay=".2s">
                            <div class="area-image">
                                <a :href="subCat.link" >
                                    <img :src="subCat.image" alt="subCat.name">
                                </a>
                            </div>
                            <div class="content">
                                <h4 style="font-size: medium; text-align: center;">
                                    <a
                                        :href="subCat.link"
                                        >{{subCat.name}}</a>
                                    </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
    import Categories from "../../../json/focus-areas.json"

    export default {
        name: 'Focus Area',
        data() {
            return {
                categories: Categories
            }
        },
        computed: {
            subCategories() {
                return this.categories.subcategories
                    .filter(subCat => subCat.id === this.subCategories);
            },
            reducedArray() {
                return this.categories.reduce((prev, obj) => {
                    let flattenedArray = obj.subCategories.map((item) => {
                        let subdiv = {};
                        subdiv["categories"] = obj.categories;
                        subdiv["subCategories"] = item.subCategories;

                        return subdiv

                    });

                    return [...prev, ...flattenedArray]
                })
            }
        },
        mounted() {
            this.reducedArray()
        },
        metaInfo: {
            title: "Tribinnov Africa - Area Of Focus",
            meta: [
                {
                    name: "description", content: "The brains behind Tribinnov Africa"
                },
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>